var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle2, _circle3, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 150,
    viewBox: "0 0 241 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 76,
    r: 74,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.352 104.942L105.834 86.8267C103.497 85.4804 101.604 81.8828 101.604 78.7863V57.4697C101.604 54.3732 103.497 52.982 105.834 54.2909L137.352 72.4062C139.689 73.7526 141.582 77.3502 141.582 80.4467V101.763C141.582 104.86 139.689 106.281 137.352 104.942Z",
    fill: "#EF406A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.209 113.44L140.289 105.055L131.754 85.7808L118.5 92.3029L126.209 113.44Z",
    fill: "#EF406A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4834 62.183L103.376 53.9331L106.854 79.6177L89.4834 62.183Z",
    fill: "#EF406A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.542 113.17L91.9862 95.0544C89.6495 93.7156 87.7637 90.1179 87.7637 87.0214V65.6899C87.7637 62.5934 89.6495 61.2022 91.9862 62.5111L123.542 80.6339C125.871 81.9728 127.765 85.5704 127.765 88.6669V109.983C127.765 113.08 125.871 114.509 123.542 113.17Z",
    fill: "#98258D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.984 61.8907V45.6976C104.984 39.1231 109.62 36.4604 115.338 39.714C121.055 42.9975 125.691 50.9931 125.691 57.5601V73.7532",
    stroke: "#29256E",
    strokeWidth: 10.46,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.842 64.6428C107.377 64.6428 109.432 63.4607 109.432 62.0026C109.432 60.5444 107.377 59.3623 104.842 59.3623C102.306 59.3623 100.251 60.5444 100.251 62.0026C100.251 63.4607 102.306 64.6428 104.842 64.6428Z",
    fill: "#29256E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.691 75.6682C128.227 75.6682 130.282 74.4861 130.282 73.028C130.282 71.5698 128.227 70.3877 125.691 70.3877C123.156 70.3877 121.101 71.5698 121.101 73.028C121.101 74.4861 123.156 75.6682 125.691 75.6682Z",
    fill: "#29256E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.22 89.11C45.22 91.38 43.38 93.22 41.11 93.22C38.84 93.22 37 91.38 37 89.11C37 86.84 38.84 85 41.11 85C43.38 85 45.22 86.84 45.22 89.11Z",
    fill: "#29256E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M239 36L221 43.5L228.5 54L239 36Z",
    stroke: "#EF406A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9996 140.672L57.0882 140.875L55.8744 134.983L47.9996 140.672Z",
    stroke: "#EF406A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173 7.67201L182.088 7.87453L180.874 1.98269L173 7.67201Z",
    fill: "#EF406A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 46.5,
    r: 7,
    stroke: "#EF406A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 15.5,
    r: 4.5,
    fill: "#98258D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M213.599 11.0347L213.599 8.72132H210.035V5.1567H207.721V8.72132H204.157L204.157 11.0347H207.721V14.5994H210.035V11.0347H213.599Z",
    fill: "#F1F1F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M193.599 128.035L193.599 125.721H190.035V122.157H187.721V125.721H184.157L184.157 128.035H187.721V131.599H190.035V128.035H193.599Z",
    fill: "#29256E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M227.409 90L232 93.4545L227.409 96.909V90Z",
    stroke: "#98258D",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M220.056 90L224.646 93.4545L220.056 96.909V90Z",
    stroke: "#7B7A8C",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.702 90L217.293 93.4545L212.702 96.909V90Z",
    stroke: "#29256E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M205.349 90L209.939 93.4545L205.349 96.909V90Z",
    stroke: "#EF406A",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198 90L202.586 93.4545L198 96.909V90Z",
    stroke: "#79DAE8",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyIcon);
export default __webpack_public_path__ + "static/media/verifyIcon.0243c9713f0265393a9b814d544e49d9.svg";
export { ForwardRef as ReactComponent };